import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import useMap from "../../hooks/useOpenLayersMap";
import MapFullScreen from "../../map/mapFullScreen";
import HomeIcon from "@mui/icons-material/Home";
import MapIcon from "@mui/icons-material/Map";
import MapTileDropdown from "../../map/mapTileDropdown";

import { GetLayer, JumpToFeatures } from "../../map/mapUtil";
import { ConvertInfrastructureAssetsToFeatures } from "./infrastructureUtil";
import { FormControl, Icon, MenuItem, Paper, Select, Typography } from "@mui/material";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useUserAuth } from "../../contexts/authContext";

export default function InfrastructureMap(props) {
    const MAP_ID = "infrastructure-map";
    const map = useMap(MAP_ID, false);

    const [typeFilter, setTypeFilter] = useLocalStorage("infrastructureMapTypeFilter", "All");
    const [mapTileDropdownOpen, setMapTileDropdownOpen] = useState(false);
    const [mapTileDropdownAnchorEl, setMapTileDropdownAnchorEl] = useState(null);

    const { userMapSettings } = useUserAuth();

    useEffect(() => {
        if (map) {
            map.addLayer(new VectorLayer({ source: new VectorSource(), name: "infrastructure_assets", zIndex: 5 }));
            handleHomeButtonClick();
        }
    }, [map]);

    useEffect(() => {
        const layer = GetLayer(map, "infrastructure_assets");
        if (!layer || !Array.isArray(props.assets)) {
            return;
        }

        const source = layer.getSource();
        if (!source) {
            return;
        }

        source.clear();
        if (props.selectedAssets?.length > 0) {
            const features = ConvertInfrastructureAssetsToFeatures(props.selectedAssets, props.infrastructureTypes, typeFilter);
            source.addFeatures(features);
            JumpToFeatures(map, features);
        } else {
            source.addFeatures(ConvertInfrastructureAssetsToFeatures(props.assets, props.infrastructureTypes, typeFilter));
        }
    }, [map, props.assets, props.selectedAssets, typeFilter]);

    const handleHomeButtonClick = () => {
        if (map && map.getView()) {
            map.getView().setCenter([userMapSettings.longitude, userMapSettings.latitude]);
            map.getView().setZoom(8);
        }
    };

    const handleMapTilesClick = (e) => {
        setMapTileDropdownOpen((prev) => !prev);
        setMapTileDropdownAnchorEl(e.currentTarget);
    };

    return (
        <Box>
            <MapFullScreen map_id={MAP_ID} map={map}>
                {props.infrastructureTypes.length > 0 && (
                    <Box sx={{ position: "absolute", zIndex: 1, right: "4px", top: "10px", display: "flex", flexDirection: "row", gap: "8px" }}>
                        <Paper
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "180px",
                                height: "38px",
                                px: "5px",
                                pl: "10px",
                                gap: "8px"
                            }}
                        >
                            <Typography variant="body1" color="textSecondary" sx={{ width: "190px" }}>
                                Type Filter:
                            </Typography>
                            <FormControl size="small" sx={{ width: "100%" }}>
                                <Select
                                    value={typeFilter}
                                    onChange={(e) => setTypeFilter(e.target.value)}
                                    renderValue={(value) => {
                                        const type = props.infrastructureTypes.find((type) => type.id === value);
                                        if (!type) {
                                            return value;
                                        }
                                        return (
                                            <Icon>
                                                <img src={`../static/2d-models/infrastructure/${type.name}.svg`} style={{ width: "100%", height: "100%" }} />
                                            </Icon>
                                        );
                                    }}
                                    sx={{ width: "100%", maxHeight: "30px" }}
                                >
                                    <MenuItem value="All">All</MenuItem>
                                    {props.infrastructureTypes.map((type) => (
                                        <MenuItem key={type.id} value={type.id} sx={{ display: "flex", gap: "6px", ml: "-6px" }}>
                                            <Icon>
                                                <img src={`../static/2d-models/infrastructure/${type.name}.svg`} style={{ width: "100%", height: "100%" }} />
                                            </Icon>
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Paper>
                        <button
                            title="View Home"
                            type="button"
                            onClick={handleHomeButtonClick}
                            className="control-button-dark"
                            style={{ width: "38px", height: "38px" }}
                        >
                            <HomeIcon />
                        </button>
                        <button
                            title="Map Tiles"
                            type="button"
                            onClick={handleMapTilesClick}
                            className="control-button-dark"
                            style={{ width: "38px", height: "38px" }}
                        >
                            <MapIcon />
                        </button>
                    </Box>
                )}
            </MapFullScreen>
            <MapTileDropdown
                mapTileDropdownOpen={mapTileDropdownOpen}
                setMapTileDropdownOpen={setMapTileDropdownOpen}
                mapTileDropdownAnchorEl={mapTileDropdownAnchorEl}
            />
        </Box>
    );
}
